<template>
  <Row :gutter="16" v-if="counts">
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :count="counts.published" imgSrc="icons/published.svg" text="Published Listings" styles="color:#fff;background:#7F7F7F;"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :count="counts.pending" imgSrc="icons/pending-list.svg" text="Pending Listings" styles="color:#fff;background:#595959;"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter :showCounter="false" imgSrc="icons/submit-article.svg" text="Active Promotions" styles="color:#fff;background:#404040;" subText="(Article, Featured, Event)" class="clickable" @click.native="handleActivePromotions"/>
    </i-col>
    <i-col :xs="24" :sm="12" :md="6">
      <CardCounter class="weekly-visits" :count="counts.week_visit" imgSrc="icons/visit-stats.svg" text="Visits this week" styles="color:#fff;background:#404040;"/>
    </i-col>
  </Row>
</template>

<script>
import CardCounter from '@/components/ui/CardCounter'

export default {
  props: {
    counts: {
      type: Object,
      default: () => []
    }
  },

  components: {
    CardCounter
  },

  methods: {
    handleActivePromotions () {
      this.$router.push({
        name: 'active-promotions'
      })
    }
  }
}
</script>
